import React from 'react';
import { useAppContext } from './useAppContext';
import { getCurrentRelationType } from '@/utils/getCurrentRelationType';

export const useCurrentRelationType = () => {
  const { account, relations } = useAppContext();
  return React.useMemo(
    () => getCurrentRelationType(account, relations),
    [account, relations],
  );
};
